import { c as _c } from "react/compiler-runtime";
import type { ApiDrop } from "@/generated/models/ApiDrop";
import { getThemeColors } from "./ParticipationDropRatingsTheme";
import type { RatingsData } from "./types";
import ParticipationDropRatingsTotalSection from "./ParticipationDropRatingsTotalSection";
import ParticipationDropRatingsVoterSection from "./ParticipationDropRatingsVoterSection";
import ParticipationDropRatingsUserSection from "./ParticipationDropRatingsUserSection";
interface ParticipationDropRatingsContainerProps {
  readonly drop: ApiDrop;
  readonly rank?: number | null | undefined;
}
export default function ParticipationDropRatingsContainer(t0) {
  const $ = _c(12);
  const {
    drop,
    rank: t1
  } = t0;
  const rank = t1 === undefined ? null : t1;
  const t2 = drop.top_raters.length > 0;
  const t3 = drop.context_profile_context?.rating ?? 0;
  let t4;
  if ($[0] !== drop.rating || $[1] !== t2 || $[2] !== t3) {
    t4 = {
      hasRaters: t2,
      userRating: t3,
      currentRating: drop.rating
    };
    $[0] = drop.rating;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const ratingsData = t4;
  const t5 = ratingsData.currentRating < 0;
  let t6;
  if ($[4] !== rank || $[5] !== t5) {
    t6 = getThemeColors(rank, t5);
    $[4] = rank;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const theme = t6;
  let t7;
  if ($[7] !== drop || $[8] !== rank || $[9] !== ratingsData || $[10] !== theme) {
    t7 = <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-x-4 tw-gap-y-2"><div className="tw-flex tw-flex-wrap tw-items-center tw-gap-x-4 tw-gap-y-2"><ParticipationDropRatingsTotalSection drop={drop} rank={rank} theme={theme} ratingsData={ratingsData} /><ParticipationDropRatingsVoterSection drop={drop} rank={rank} theme={theme} ratingsData={ratingsData} /></div><ParticipationDropRatingsUserSection drop={drop} rank={rank} theme={theme} ratingsData={ratingsData} /></div>;
    $[7] = drop;
    $[8] = rank;
    $[9] = ratingsData;
    $[10] = theme;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
}